module.exports = __webpack_public_path__ + "img/2.08c95d5f.png";